import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledDiv = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
`

const DataTableToolbarRow = ({children, ...otherProps}) => <StyledDiv {...otherProps}>{children}</StyledDiv>

DataTableToolbarRow.propTypes = {
  children: PropTypes.any
}

export {DataTableToolbarRow}
